// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_eS","advertDetailHeaderLocation__value":"c-m_eT"};